export default __webpack_public_path__ + "static/media/pdf.8b796e34.png";